import { render } from "./EditPlantEvaluationColumns.vue?vue&type=template&id=d6b552d6"
import script from "./EditPlantEvaluationColumns.vue?vue&type=script&lang=js"
export * from "./EditPlantEvaluationColumns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__